import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './home-products-2.css';

const CARD_DATA = [
    // Paper Bags Category
    {
        title: "White Paper Bags",
        category: "PAPER BAGS",
        description: "White paper bags are lightweight, and durable, offering a clean, versatile, and recyclable packaging solution for diverse applications.",
        mainImage: '/assets/products-with-logo/paper-bags/white-paper-bags.jpg',
        sideImage: '/assets/products-with-logo/paper-bags/white-paper-bags.jpg',
        path: '/white-paper-bags'
    },
    {
        title: "Brown Paper Bags",
        category: "PAPER BAGS",
        description: "Brown paper bags are lightweight, and durable, offering a natural, versatile, and eco-friendly packaging solution for diverse applications.",
        mainImage: '/assets/products-with-logo/paper-bags/brown-paper-bags-small-size.jpg',
        sideImage: '/assets/products-with-logo/paper-bags/brown-paper-bags-large-size.png',
        path: '/brown-paper-bags'
    },
    {
        title: "Self-Opening Square Paper Bags",
        category: "PAPER BAGS",
        description: "Self-Opening Square Paper Bags feature a sturdy flat base and pre-creased folds for effortless use, combining durability and versatility to meet diverse packaging needs.",
        mainImage: '/assets/products-with-logo/paper-bags/sos-bag-logo-small.jpeg',
        sideImage:'/assets/products-with-logo/paper-bags/sos-bag-logo-large.jpeg',
        path: '/sos'
    },
    {
        title: "Take Away Bags",
        category: "PAPER BAGS",
        description: "Takeaway bags are durable and spacious, designed for secure and convenient packaging, offering grease-resistant and eco-friendly solutions for food delivery and takeout orders.",
        mainImage: '/assets/products-with-logo/paper-bags/take-away-bags.jpg',
        sideImage: '/assets/products-with-logo/paper-bags/take-away-bags-small.jpg',
        path: '/take-away-bags'
    },
    {
        title: "Promotional Bags",
        category: "PAPER BAGS",
        description: "High-quality promotional bags with premium finishing and customizable designs, perfect for enhancing brand visibility and creating lasting impressions at events and retail outlets.",
        mainImage: '/assets/products-with-logo/paper-bags/promotional-bags-small.jpg',
        sideImage: '/assets/products-with-logo/paper-bags/promotional-bags.jpg',
        path: '/promotional-bags'
    },
    // {
    //     title: "Wrappers",
    //     category: "PAPER BAGS",
    //     description: "Premium quality wrappers offering superior protection and versatility, suitable for various packaging needs from food service to industrial applications, retail merchandise to gift wrapping solutions.",
    //     mainImage: '/assets/products-with-logo/paper-bags/wrappers-small.jpg',
    //     sideImage: '/assets/products-with-logo/paper-bags/wrappers.jpg',
    //     path: '/wrappers'
    // },
    // Courier Bags Category
    {
        title: "POD Courier Bags",
        category: "COURIER BAGS",
        description: "Professional POD courier bags featuring tamper-evident seals and tracking capabilities, ensuring secure delivery with proof of dispatch and receipt for all your shipping needs.",
        mainImage: '/assets/products-with-logo/courier-bags/pod-courier-small.png',
        sideImage: '/assets/products-with-logo/courier-bags/pod-courier-large.png',
        path: '/pod-courier-bags'
    },
    {
        title: "Non-POD Courier Bags",
        category: "COURIER BAGS",
        description: "Standard courier bags offering basic shipping protection without tracking features, perfect for routine deliveries and cost-effective shipping solutions where proof of delivery isn't required.",
        mainImage: '/assets/products-with-logo/courier-bags/non-pod-small.jpeg',
        sideImage: '/assets/products-with-logo/courier-bags/non-pod-large (1).jpeg',
        path: '/non-pod-courier-bags'
    },
    // Packaging Products Category
    {
        title: "Ld Shrink",
        category: "PACKAGING PRODUCTS",
        description: "Premium low-density shrink film providing superior product protection and clarity, perfect for bundling, wrapping, and securing items with excellent shrinkage properties and durability for various packaging applications.`",
        mainImage: '/assets/products-with-logo/packaging-products/ld-shrink-film-small.jpg',
        sideImage: '/assets/products-with-logo/packaging-products/ld-shrink-film.jpg',
        path: '/ld-shrink-film'
    },
    {
        title: "Liners",
        category: "PACKAGING PRODUCTS",
        description: "High-grade container liners engineered to prevent leakage and contamination, providing secure protection for bulk materials during storage and transportation with moisture-resistant and durable properties.",
        mainImage: '/assets/products-with-logo/packaging-products/liners-small (2).jpg',
        sideImage: '/assets/products-with-logo/packaging-products/liners-long.jpg',
        path: '/liners'
    },
    {
        title: "Packaging Films",
        category: "PACKAGING PRODUCTS",
        description: "High-quality packaging films offering superior protection and versatility, designed for multiple applications with excellent barrier properties, ensuring product safety and integrity throughout storage and distribution.",
        mainImage: '/assets/products-with-logo/packaging-products/packading-films-small.jpg',
        sideImage: '/assets/products-with-logo/packaging-products/packaging-films.jpg',
        path: '/packaging-films'
    }
];

const PaperBagCard = ({ data }) => {
    const [isHovered, setIsHovered] = useState(false);
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(data.path);
    };

    return (
        <div className="col-md-4 mb-4">
            <div 
                className="paper-bag-card"
                onClick={handleClick}
            >
                <div 
                    className="paper-bag-image-container"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <div className={`paper-bag-main-image ${isHovered ? 'opacity-0' : 'opacity-100'}`}>
                        <img
                            className="paper-bag-img"
                            src={data.mainImage}
                            alt={data.title}
                        />
                    </div>
                    
                    <div className={`paper-bag-hover-content ${isHovered ? 'opacity-100' : 'opacity-0'}`}>
                        <div className="paper-bag-left-content">
                            <img
                                className="paper-bag-img"
                                src={data.sideImage}
                                alt={`${data.title} Side`}
                            />
                        </div>
                        <div className="paper-bag-right-content">
                            <p>{data.description}</p>
                        </div>
                    </div>
                </div>
                
                <div className="paper-bag-title-container">
                    <h3>{data.title}</h3>
                </div>
            </div>
        </div>
    );
};

const PaperBagGallery = () => {
    const [activeCategory, setActiveCategory] = useState("ALL");
    
    const filteredProducts = CARD_DATA.filter(product => 
        activeCategory === "ALL" || product.category === activeCategory
    );

    return (
        <section className="products-section py-5">
            <div className="container-fluid p-4">
                <div className="text-center mb-5">
                    <p className="product-sub-heading text-uppercase mb-2">OUR PRODUCTS LIST</p>
                    {/* <h2 className="paper-bag-section-title">What We're Offering</h2> */}
                </div>

                <div className="text-center mb-4">
                    <button 
                        className={`product-sub-heading text-uppercase mb-2 mx-2 ${activeCategory === "ALL" ? "active" : ""}`}
                        onClick={() => setActiveCategory("ALL")}
                    >
                        ALL
                    </button>
                    <button 
                        className={`product-sub-heading text-uppercase mb-2 mx-2 ${activeCategory === "PAPER BAGS" ? "active" : ""}`}
                        onClick={() => setActiveCategory("PAPER BAGS")}
                    >
                        PAPER BAGS
                    </button>
                    <button 
                        className={`product-sub-heading text-uppercase mb-2 mx-2 ${activeCategory === "COURIER BAGS" ? "active" : ""}`}
                        onClick={() => setActiveCategory("COURIER BAGS")}
                    >
                        COURIER BAGS
                    </button>
                    <button 
                        className={`product-sub-heading text-uppercase mb-2 mx-2 ${activeCategory === "PACKAGING PRODUCTS" ? "active" : ""}`}
                        onClick={() => setActiveCategory("PACKAGING PRODUCTS")}
                    >
                        PACKAGING PRODUCTS
                    </button>
                </div>

                <div className="row">
                    {filteredProducts.map((data, index) => (
                        <PaperBagCard key={index} data={data} />
                    ))}
                </div>
            </div>
            <style>{`
                .product-sub-heading.active {
                    background-color: #000;
                    color: #fff;
                }
                .mx-2 {
                    margin-left: 0.5rem;
                    margin-right: 0.5rem;
                }
            `}</style>
        </section>
    );
};

export default PaperBagGallery;